import styled, { keyframes } from 'styled-components';
import { fadeInLeftBig } from 'react-animations';
import { GlobalWrapperStyles } from '../utils/sharedStyles';

const animation = {
    fadeInLeftBig: keyframes`${fadeInLeftBig}`,
    gradient: keyframes`
    0%   { background-position: 0% 50% }
    50%  { background-position: 100% 50% }
    100% { background-position:0% 50% }
  `,
};

export const AnimatedFadeInDiv = styled.div`
    animation: 2s ${animation['fadeInLeftBig']};
    transform: translate3d(0, 0);
    position: fixed;
    z-index: 101;
`;

export const AnimatedGradientBox = styled(GlobalWrapperStyles)`
    &&& {
        animation: ${animation['gradient']} 2s ease-in-out 0s infinite;

        cursor: pointer;

        width: 45px;
        height: 35px;
        padding: 4px;

        background: #529ec3 linear-gradient(270deg, #3c94bfc9, #3c94bf);
        background-size: 400% 400%;
        opacity: 0.7;

        z-index: 100;

        &:hover {
            opacity: 1;
        }
    }
`;
